module.exports = __webpack_public_path__ + "img/slide-1-mob.bf7515b.webp";